import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from "@angular/router"

import { LoginService } from '../../service/login.service';
import { Token } from '../../manager/token';
import { NotificationService } from 'src/app/service/notification.service';
import { Notification } from 'src/app/manager/notification';
import { ResponseHelper } from 'src/app/manager/response.helper';
import { RedirectHelper } from 'src/app/manager/redirect'
import { AnalyticsService } from 'src/app/analytics.service';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { DomSanitizer } from '@angular/platform-browser';
import { InventoryService } from 'src/app/service/client-configuration/inventory.service';
import { CommonService } from 'src/app/service/common-service';
import { environment } from '../../../environments/environment';
import { HeaderComponent } from 'src/app/common-components/header/header.component';
import { CommonModule } from '@angular/common';

 import { ColDef, GridOptions } from 'ag-grid-community';
import { AgGridModule } from 'ag-grid-angular';
import { DisclaimerComponent } from '../disclaimer/disclaimer.component';
import { BASE_AG_GRID_OPTIONS } from 'src/app/service/common-config';
import { CapsLockDirective } from 'src/app/service/caps-lock.directive';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [LoginService],
  standalone: true,
    imports: [HeaderComponent, FormsModule, CommonModule, ReactiveFormsModule,AgGridModule, DisclaimerComponent,
      CapsLockDirective
    ]
})
export class LoginComponent implements    OnInit {
gridOptions: GridOptions = {
  pagination: true,
  paginationPageSize: 15,
  rowSelection : 'single',
    suppressColumnVirtualisation: true,
  suppressDragLeaveHidesColumns: true,
...BASE_AG_GRID_OPTIONS,
};

  MyForm: UntypedFormGroup;
  DisplayError: Boolean = false;
  DisableSubmit: Boolean = false;
  Token: Token;
  CurrentYear;
  ResponseHelper
  captchaArray = [];
  gradientColor = null;
  captchaData = '';
  showCaptcha: any;
  uniqueKey: any;
  isCaptcha: boolean = false;
  isLoaded: boolean = false;
  isShow: boolean = false
  version: string;
  ReleasedVersion:string;
  showCopyright: boolean = false;
  remoteIp: any;

  capsLockOn: boolean = false;
  showPassword: boolean = false;

  isProduction = false;
  
  constructor( 
    public loginservice: LoginService,
    private notificationservice: NotificationService,
    private RedirectHelper: RedirectHelper,
 //   private idle: Idle, private keepalive: Keepalive,
    private analyticsService: AnalyticsService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private inventoryService: InventoryService,
    public commonService: CommonService,
  ) {

    this.CurrentYear = (new Date()).getFullYear();
    this.version = environment.version;
    this.ReleasedVersion = environment.releasedVersion;
    this.isProduction = environment.production
  }

  ngOnInit() {
    // this.RedirectHelper = new RedirectHelper(this.router)
    this.createForm();
    this.Token = new Token(this.router);
    this.Token.ClearUserData();
    this.ResponseHelper = new ResponseHelper(this.notificationservice);
    this.callCaptcha();

  }

    getIP(){
    this.loginservice.GetClientIP().subscribe(
      (data:any) => {
        if (data.remoteIp != null) {
          this.remoteIp = data.remoteIp;
          console.log('response : ', data.remoteIp);
          this.FormSubmit();
        } else {
          this.remoteIp = 'NA';
          this.FormSubmit();
        }
      }
    ), err => {
      this.remoteIp = 'NA';
      this.FormSubmit();
    }
  }

  logEvent() {
    this.analyticsService.logEvent('Login').subscribe((response) => {
      console.log('logEvent : ', response);
    }, (error) => {
      console.log('logEvent : ', error);
    });
  }
  FormSubmit() {
    this.DisableSubmit = true;
    this.MyForm.patchValue({ UniqueKey: this.uniqueKey });
    this.isLoaded = true;
    // sending password to service to encrypt
    const passwordEncrypted = this.commonService.encryptData(this.MyForm.value.password)
 let remoteIP = this.commonService.encryptData(this.remoteIp);
    if (this.MyForm.valid) {
      // to update encrypted password in form
      // this.MyForm.patchValue({ password : passwordEncrypted });

    this.MyForm.patchValue({ ClientIp : remoteIP });
      let storeFormValue = JSON.stringify(this.MyForm.value);
      let getFormValue = JSON.parse(storeFormValue);
      getFormValue.password = passwordEncrypted;

      this.DisplayError = false;
      this.loginservice.Login(getFormValue).subscribe(
        (data: any) => {
          this.isLoaded = false;
          // this.ResponseHelper.GetSuccessResponse(data);
          if (data.Data.Token != null) {
            setTimeout(() => {
              const response = data.Data;
              console.log('response : ', response);
              sessionStorage.setItem('userID', response?.Id);

              // response['enableTFAuth'] = { enable: true, status: "incomplete" };
              if (response.enableTFAuth && response.enableTFAuth.enable == true) {
                localStorage.setItem('token', data.Data.Token);
                sessionStorage.setItem("enableTFAuth", JSON.stringify(response.enableTFAuth));
                this.Token.SetLoginAESToken(data.Data.Token)
                this.Token.SetLoginClientData(data.Data);

                // call function for multi grid isMultiGrid or not
                this.getIsMultiGrid();
                
                this.router.navigate(['/two-factor-auth']);
              }
              else {
                // this.router.navigate(['/Login']);
                this.Token.SetLoginAESToken(data.Data.Token)
                //this.Token.SetLoginToken(_jwtToken);
                this.Token.SetLoginClientData(data.Data);
                
                // call function for multi grid isMultiGrid or not
                this.getIsMultiGrid();

                if (data.Data.First_Login == true) {
                  this.isShow = true
                  // this.router.navigate(['/change-password']);
                }
                else {
                  this.RedirectHelper.redirectByRole()

                  // // call function for multi grid isMultiGrid or not
                  this.getIsMultiGrid();
                }
              }
              this.logEvent();
              this.initiateTime();
            }, 2000);
          }
          else {

            const response = data
            console.log('Login err : ', response);
            const Message = response && response.Message && response.Message.length > 0 ? response.Message[0] : null;
            sessionStorage.setItem('UserID', response.Data.Id);

            if (Message.Message != 'Invalid captcha.') {
              this.callCaptcha();
            }
            if (Message && Message.Message == 'Your password has expired, Please reset') {
              this.router.navigate(['/reset-password']);
            }
            // Your password has expired, Please reset
            this.DisableSubmit = false;
          }
        }, (err) => {
          this.isLoaded = false;

          this.ResponseHelper.GetFaliureResponse(err)
          this.DisableSubmit = false;
          const response = err
          console.log('Login err : ', err);
          if (err.error != null) {
            if (err.error.Data == null && err.error.Message[0].Message != 'Invalid captcha.') {
              this.callCaptcha();
            }
          }

          const Message = response && response.Message && response.Message.length > 0 ? response.Message[0] : null;
          if (Message && Message.Message == 'Invalid User credentials.') {

          }
          this.logEvent();
        }
      );
    }
    else {
      this.DisplayError = true;
      this.DisableSubmit = false;
      this.isLoaded = false;
    }
  }

  initiateTime() {
    // sets an idle timeout of 5 seconds, for testing purposes.
    this.loginservice.getTimeout().subscribe((response: any) => {
      console.log('idleTime response: ', response);
      let idleTime = Number(response.Data.Time_In_Minutes) * 60;
      idleTime = idleTime - 10;

      console.log('idleTime : ', idleTime);
      // let data = [{ Message: "Session Timeout Started", Type: "SUCCESS" }]
      // this.notificationservice.ChangeNotification(data);
      const timeOutTime = 10;
      sessionStorage.setItem('sessionTime', idleTime.toString());
   //   this.idle.setIdle(idleTime);
      // sets a timeout period of 10 seconds. after 10 seconds of inactivity, the user will be considered timed out.
  //    this.idle.setTimeout(timeOutTime);
  //    this.idle.watch();
    }, (error) => {
      console.log('idleTime error : ', error);
    })
  }
  createForm() {
    this.MyForm = new UntypedFormGroup({
      username: new UntypedFormControl('', [Validators.required
      ]),
      password: new UntypedFormControl('', [Validators.required
      ]),
      captchaData: new UntypedFormControl('', [Validators.required]),
      UniqueKey: new UntypedFormControl('', null),
      ClientIp:new UntypedFormControl('',null)
    });
    // console.log('myForm : ',this.MyForm);
  }

  // Call API for Captcha
  callCaptcha() {
    this.isCaptcha = true;
    this.loginservice.loginCaptcha().subscribe((res: any) => {
      this.isCaptcha = false;
      // this.ResponseHelper.GetSuccessResponse(res)
      let captcha = res.Data.responseCaptcha;
      this.uniqueKey = res.Data.UniqueKey;
      this.convertToImage(captcha);
      // this.captchaArray.push(this.showCaptcha)
    }, error => {
      this.ResponseHelper.GetFaliureResponse(error)
    })
    this.MyForm.patchValue({ captchaData: '' })
  }

  convertToImage(captcha) {
    this.showCaptcha = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${captcha}`);
    console.log(this.showCaptcha, 'this.showCaptcha');
  }

  // Redirect to forgot-password page
  redirectForgot(menu) {
    this.router.navigate([menu])
  }

  // call api for multi grid isMultiGrid or not
  getIsMultiGrid() {
    var tokens = new Token(this.router);
    let userdata = tokens.GetUserData();
    let ClientId = userdata.Clients[0].Client_Id;
    let userRole = userdata.Role.toLowerCase();

    if (userRole == 'agent') {
      this.inventoryService.getIsMultigrid(ClientId).subscribe((res: any) => {
        sessionStorage.setItem('isMultiGrid', JSON.stringify(res.Data));
        // this.ResponseHelper.GetSuccessResponse(res);
      }, err => {
        this.ResponseHelper.GetFaliureResponse(err);
      });
    }
  }
  // on closing the disclaimer modal
  closeModal() {
    this.isShow = false
    this.DisableSubmit = false;
    this.MyForm.patchValue({ captchaData: '' })
    this.callCaptcha();

  }
  // on clicking the accept button in disclaimer modal
  onAcceptDiscalimer() {
    this.isShow = false
    this.router.navigate(['/change-password']);
  }

  ShowCopyright(){
    this.showCopyright = true;
  }

  closeCopyright(){
    this.showCopyright = false;
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }
  // check condition caps lock on/off
  checkCapsLock(event: KeyboardEvent) {
    this.capsLockOn = event.getModifierState && event.getModifierState('CapsLock');
  }
}
